module.exports = __webpack_public_path__ + "assets/img/mecha-56664305.png";